import { Fragment, useEffect, useState } from "react";
import { motion } from "framer-motion";
import LazyLoadingImg from "../Components/LazyLoadingImg";
import useWindowWidth from "../../hooks/useWindowWidth";

export default function Client() {
  const width = useWindowWidth();
  const isMobile = width <= 768;

  const MotionSwitch = ({
    isMobile,
    as = "div",
    className,
    children,
    initial,
    inView,
    transition,
    ...rest
  }) => {
    const Tag = as;
    if (!isMobile) {
      return (
        <Tag className={className} {...rest}>
          {children}
        </Tag>
      );
    }
    const MotionTag = motion[as] ?? motion.div;
    return (
      <MotionTag
        className={className}
        initial={initial}
        whileInView={inView}
        viewport={{ once: true, amount: 0.5 }}
        transition={transition ?? { duration: 0.6, ease: "easeOut" }}
        {...rest}
      >
        {children}
      </MotionTag>
    );
  };

  return (
    <Fragment>
      <div className="container-fluid horizontal-padding">
        <MotionSwitch
          isMobile={isMobile}
          as="div"
          className="px-lg-6 a2Features text-center position-relative"
          initial={{ opacity: 0, y: -50 }}
          inView={{ opacity: 1, y: 0 }}
        >
          <h2>WHAT OUR CLIENTS THINK ABOUT US !</h2>
        </MotionSwitch>

        <div className="row mt-5">
          <MotionSwitch
            isMobile={isMobile}
            as="div"
            className="col-md-7 mb-3 col-12 px-md-5 pb-md-0 pb-5 position-relative"
            initial={{ opacity: 0, x: -80 }}
            inView={{ opacity: 1, x: 0 }}
          >
            <LazyLoadingImg
              src="/images/a2-our-clients-think-border.png"
              alt="a2-our-clients-think-border"
            />
            <div className="testimonial-card">
              <div className="testimonial-blockquote">
                <p className="testimonial-text">
                  We've been working with <b>SprigStack</b> for several years
                  now and couldn't be happier with the partnership. As a result,
                  we use them as our only third-party agency for this and new
                  projects across our subsidiaries.
                </p>
              </div>
              <div className="testimonial-author mt-md-5">
                <h3>Jason Barresi</h3>
                <p>Director at Address Two</p>
              </div>
            </div>
          </MotionSwitch>

          <MotionSwitch
            isMobile={isMobile}
            as="div"
            className="col-md-5 col-12 d-flex align-items-end justify-content-start"
            initial={{ opacity: 0, y: 80 }}
            inView={{ opacity: 1, y: 0 }}
          >
            <LazyLoadingImg
              src="/images/client-jason-barresi.png"
              alt="client-jason-barresi"
              className="client-jason-barresi"
              width="250"
            />
          </MotionSwitch>
        </div>
      </div>
    </Fragment>
  );
}
